import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, switchMap } from 'rxjs';
import { UserService } from '@services/user/user.service';
import { Building } from '@app/shared/models/building.interface';
import { takeUntil } from 'rxjs/operators';
import { AdmStaticFilterComponent } from '@app/driver-metrics/static/adm-static-filter/adm-static-filter.component';
import { DriverMetricsStaticTableComponent } from '@app/driver-metrics/static/driver-metrics-static-table/driver-metrics-static-table.component';
import { DriverStaticFilterService } from '@app/driver-metrics/static/driver-static-filter.service';
import { BuildingService } from '@services/building/building.service';

@Component({
  selector: 'app-driver-metrics-static',
  imports: [AdmStaticFilterComponent, DriverMetricsStaticTableComponent],
  templateUrl: './driver-metrics-static.component.html',
  styleUrl: './driver-metrics-static.component.scss'
})
export class DriverMetricsStaticComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  building: Building;

  constructor(
    private readonly userService: UserService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly filterService: DriverStaticFilterService,
    private readonly buildingService: BuildingService
  ) {}

  ngOnInit(): void {
    this.buildingService.currentBuilding$.pipe(takeUntil(this.destroy$)).subscribe((building) => {
      if (this.filterService.filterCriteriaValue?.buildingId !== building?.id) {
        this.filterService.resetFilterCriteria();
      }
    });

    this.activatedRoute.parent.params
      .pipe(
        takeUntil(this.destroy$),
        switchMap((params) => this.userService.getBuilding(params.buildingId))
      )
      .subscribe((building) => {
        this.building = building;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
